import React, {useState, useEffect} from "react";
import ClientTypesList from "./ClientTypesList";
import ClientTypeEditor from "./ClientTypeEditor";
import Notification from "../Common/Notification";

const ClientTypesSettings = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedAll, setSelectedAll] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [showEditor, setShowEditor] = useState(false);
    const [currentClientType, setCurrentClientType] = useState(null);
    const [notification, setNotification] = useState({
        show: false,
        type: 'success',
        message: '',
    });

    // Debounce search term
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
            setCurrentPage(1); // Reset to first page when search changes
        }, 300);

        return () => clearTimeout(timer);
    }, [searchTerm]);

    // Function to show a notification
    const showNotification = (type, message) => {
        setNotification({
            show: true,
            type,
            message,
        });

        // Auto hide after 5 seconds for success notifications
        if (type === 'success') {
            setTimeout(() => {
                setNotification(prev => ({...prev, show: false}));
            }, 5000);
        }
    };

    // Function to hide notification
    const hideNotification = () => {
        setNotification(prev => ({...prev, show: false}));
    };

    // Handle create new client type
    const handleCreateClientType = () => {
        setCurrentClientType(null);
        setShowEditor(true);
    };

    // Handle edit client type
    const handleEditClientType = (clientType) => {
        setCurrentClientType(clientType);
        setShowEditor(true);
    };

    // Handle back from editor
    const handleCloseEditor = () => {
        setShowEditor(false);
        setCurrentClientType(null);
    };

    return (
        <div>
            <ClientTypesList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                debouncedSearchTerm={debouncedSearchTerm}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                selectedAll={selectedAll}
                setSelectedAll={setSelectedAll}
                showNotification={showNotification}
                onCreateClientType={handleCreateClientType}
                onEditClientType={handleEditClientType}
            />

            {showEditor && (
                <ClientTypeEditor
                    clientType={currentClientType}
                    onClose={handleCloseEditor}
                    showNotification={showNotification}
                />
            )}

            {/* Notification */}
            {notification.show && (
                <Notification
                    type={notification.type}
                    message={notification.message}
                    onClose={hideNotification}
                />
            )}
        </div>
    );
};

export default ClientTypesSettings;
